import { Component, OnInit, Input } from '@angular/core';
import { ImplementSummaryForEquipmentDetails, SchematicAndObservationPointDetails, WorstEvalForCrackAndNormal, ImplementForEquipmentDetails } from '../../equipment-details/equipment-details.model';

@Component({
  selector: 'app-fecr-implement-details-header',
  templateUrl: './fecr-implement-details-header.component.html',
  styleUrls: ['./fecr-implement-details-header.component.scss']
})
export class FecrImplementDetailsHeaderComponent implements OnInit {

  @Input() Implemetdetails: ImplementSummaryForEquipmentDetails = new ImplementSummaryForEquipmentDetails();
  @Input() evaldetails: ImplementForEquipmentDetails = new ImplementForEquipmentDetails();


  ngOnInit() {
  }


  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return " WornPctCell evalColorA";
    }
    else if ((wornPct > 30) && (wornPct <= 60)) {
      return " WornPctCell evalColorB";
    }
    else if ((wornPct > 60) && (wornPct <= 80)) {
      return " WornPctCell evalColorC";
    }
    else if (wornPct > 80) {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";

  }

}

